export enum Curriculum {
  CURRICULUM_UNSPECIFIED = "CURRICULUM_UNSPECIFIED",
  HW = "HW",
  HM = "HM",
  DPP = "PT2V2",
}
